import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import color from 'color';
import { isFunction } from '@/se/utilities/check';

const Circle = styled.circle`
  transition: stroke-dashoffset 0.35s;
  transform: rotate(-90deg);
  transform-origin: 50% 50%;
`;

const ProgressRing = ({ radius, stroke, progress, style, color: strokeColor }) => {
  const circleRef = useRef();

  const normalizedRadius = radius - stroke * 2;
  const circumference = normalizedRadius * 2 * Math.PI;

  useEffect(() => {
    if (isFunction(progress)) {
      let animationFrameId;

      function loop() {
        const circle = circleRef.current;

        if (circle) {
          const currentProgress = progress(new Date());
          const strokeDashoffset = circumference - (currentProgress / 100) * circumference;
          circle.style.strokeDashoffset = strokeDashoffset;
        }

        animationFrameId = requestAnimationFrame(loop);
      }

      loop();

      return () => {
        cancelAnimationFrame(animationFrameId);
      };
    } else {
      const circle = circleRef.current;

      if (circle) {
        circle.style.strokeDashoffset = strokeDashoffset;
      }

      const strokeDashoffset = circumference - (progress / 100) * circumference;

      circleRef.current.style.strokeDashoffset = strokeDashoffset;
    }
  }, [progress, normalizedRadius, circumference]);

  return (
    <svg height={radius * 2} width={radius * 2} style={style}>
      <Circle
        stroke={color(strokeColor).alpha(0.2).string() || 'white'}
        fill="transparent"
        strokeWidth={stroke}
        stroke-width={stroke}
        r={normalizedRadius}
        cx={radius}
        cy={radius}
      />
      <Circle
        ref={circleRef}
        stroke={strokeColor || 'white'}
        fill="transparent"
        strokeWidth={stroke}
        strokeDasharray={circumference + ' ' + circumference}
        stroke-width={stroke}
        r={normalizedRadius}
        cx={radius}
        cy={radius}
      />
    </svg>
  );
};
export default ProgressRing;
